import { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { ReduxState } from "./store/state";
import { checkLoginCookies } from "./store/auth/initiators/checkLoginCookies";
import { autoLocateDevice } from "./store/location/initiators";

import LandingPage from "./pages/LandingPage";
import HomePage from "./pages/home/HomePage";
import UserPage from "./pages/user/UserPage";
import CartPage from "./pages/cart/CartPage";

interface AppProps {
  checkLoginCookies: () => void;
  autoLocateDevice: () => void;
}

class App extends Component<AppProps> {
  componentDidMount(): void {
    this.props.checkLoginCookies()
    this.props.autoLocateDevice()
  }

  render() {
    return (
          <div>
            <Router>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/:pageKey" element={<LandingPage />} />
                <Route path="/user" element={<UserPage />} />
                <Route path="/cart" element={<CartPage />} />
              </Routes>
            </Router>
          </div>
        );
  }
}

const mapStateToProps = (state: ReduxState) => {
  const { selectedPage } = state.page;
  return { selectedPage };
};

export default connect(mapStateToProps, {
  checkLoginCookies,
  autoLocateDevice
})(App);

